import DeleteAppendedItemModal from './DeleteAppendedItemModal'

export default DeleteAppendedItemModal
